
import { LeadSource } from "../../api/models/leadSource";
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from "../utils";

const ACTION_LOAD_LEAD_SOURCE_REQUEST =
  "ENTITIES/LOAD_LEAD_SOURCE_REQUEST";
const ACTION_LOAD_LEAD_SOURCE_SUCCESS =
  "INTENT/LOAD_LEAD_SOURCE_SUCCESS";
const ACTION_LOAD_LEAD_SOURCE_ERROR =
  "INTENT/LOAD_LEAD_SOURCE_ERROR";

export interface LeadSourceState {
    leadSource: LeadSource[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: LeadSourceState = {
    leadSource: [],
  isLoaded: false,
  isLoading: false,
};

type LeadSourceRequestActionType = IAction<
  typeof ACTION_LOAD_LEAD_SOURCE_REQUEST
>;

type LeadSourceSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_LEAD_SOURCE_SUCCESS,
  LeadSource[]
>;

type LeadSourceErrorActionType = IAction<
  typeof ACTION_LOAD_LEAD_SOURCE_ERROR
>;

type Actions =
  | LeadSourceRequestActionType
  | LeadSourceSuccessActionType
  | LeadSourceErrorActionType;

export const loadLeadSourceRequestAction = (): LeadSourceRequestActionType => {
  return createAction(ACTION_LOAD_LEAD_SOURCE_REQUEST);
};

export const loadLeadSourceSuccessAction = (
  data: LeadSource[]
): LeadSourceSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_LEAD_SOURCE_SUCCESS, data);
};

export const loadLeadSourceErrorAction = (): LeadSourceErrorActionType => {
  return createAction(ACTION_LOAD_LEAD_SOURCE_ERROR);
};

// reducer
export const leadSourceReducer = (
  state: LeadSourceState = initialState,
  action: Actions
):LeadSourceState => {
  switch (action.type) {
    case ACTION_LOAD_LEAD_SOURCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_LEAD_SOURCE_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_LEAD_SOURCE_SUCCESS:
      return {
        ...state,
        leadSource: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
